import React from 'react';
import Checkmark from '@mui/icons-material/Check';

const Checkbox = ({ label, name, checked, onChange }) => {
    
    const handleClick = (event) => {
        event.preventDefault();
        event.stopPropagation();
        onChange(!checked);
    }

    const handleKeyDown = (event) => {
        if (event.key === 'Enter') {
            handleClick(event);
        }
    }

    return (
        <div className="checkbox-container">
            <label className='checkbox-label'>
                <button
                    type="button"
                    className={`checkbox-indicator ${checked? 'checked' : ''}`}
                    onClick={(e) => handleClick(e)}
                    onKeyDown={(e) => handleKeyDown(e)}
                    tabIndex="0"
                >
                    <input 
                        type="checkbox" 
                        name={name} 
                        checked={checked ? true : false}
                        onChange={() => {}}
                        style={{ display: 'none' }}
                    />
                    <Checkmark style={{ fontWeight: 'bold' }} />
                </button>
                {label}
            </label>
        </div>
    );
}

export default Checkbox;